// src/Pages/Auth/Register.jsx
import React, { useState } from "react";
import { FaUser, FaLock, FaMobileAlt, FaIdCard, FaChevronDown } from "react-icons/fa";
import logo from "../../Assets/images/logo.jpg";
import InputField from "../../Components/InputField";
import Button from "../../Components/Button";
import Loading from "../../Components/Loading";
import { Link } from "react-router-dom";
import useRegisterForm from "../../Hooks/Auth/useRegisterForm";
import { handlePhoneInputKeyPress } from '../../Utils/validateForm';
import Alert from '../../Components/Alert';
import { governorates } from "../../Data/governorates";

const Register = () => {
  const { values, errors, apiError, success, isLoading, handleChange, handleSubmit } = useRegisterForm();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <div className="min-h-screen bg-light flex items-center justify-center direction-rtl">
      <div className="w-full max-w-lg p-6 bg-light rounded-2xl shadow-md text-dark">
        <div className="flex flex-col items-center mb-6">
          <img src={logo} alt="Logo" className="w-16 h-16" />
          <h3 className="text-2xl font-bold mt-2 text-main1">مرحبا بك</h3>
          <p className="text-sm text-grayish-600">بإنشاء حساب مجاني</p>
        </div>

        <form className="space-y-4" onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              name="first_name"
              placeholder="الاسم الأول"
              Icon={FaUser}
              type="text"
              value={values.first_name}
              onChange={handleChange}
              error={errors.first_name}
            />
            <InputField
              name="father_name"
              placeholder="اسم الأب"
              Icon={FaUser}
              type="text"
              value={values.father_name}
              onChange={handleChange}
              error={errors.father_name}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              name="last_name"
              placeholder="الكنية"
              Icon={FaUser}
              type="text"
              value={values.last_name}
              onChange={handleChange}
              error={errors.last_name}
            />
            <InputField
              name="phone_number"
              placeholder="رقم الموبايل"
              Icon={FaMobileAlt}
              type="text"
              value={values.phone_number}
              onChange={handleChange}
              error={errors.phone_number}
              onKeyPress={e => handlePhoneInputKeyPress(e, values.phone_number)}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="w-full">
              <div className="relative">
                <button
                  type="button"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className={`flex justify-between items-center px-4 py-2 rounded-xl border text-sm font-medium transition-all duration-150 bg-grayish text-main1 hover:bg-main1/10 w-full ${errors.governorate_name ? "border-red-500" : "border-transparent"
                    } focus:border-main1`}
                >
                  <span>{values.governorate_name || "المحافظة"}</span>
                  <FaChevronDown
                    className={`transition-transform ${dropdownOpen ? "rotate-180" : ""}`}
                  />
                </button>

                {dropdownOpen && (
                  <div className="absolute right-0 mt-2 w-full bg-light rounded-xl shadow-lg border border-gray-200 overflow-hidden z-10 max-h-60 overflow-y-auto scrollbar-hide">
                    {governorates.map((governorate) => (
                      <div
                        key={governorate}
                        onClick={() => {
                          handleChange({ target: { name: "governorate_name", value: governorate } });
                          setDropdownOpen(false);
                        }}
                        className={`px-4 py-2 text-sm cursor-pointer transition text-right ${values.governorate_name === governorate
                          ? "bg-main1 text-light"
                          : "hover:bg-grayish/50 text-main1"
                          }`}
                      >
                        {governorate}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {errors.governorate_name && (
                <p className="text-red-500 text-xs mt-1 pr-2 text-right">{errors.governorate_name}</p>
              )}
            </div>
            <InputField
              name="national_id"
              placeholder="الرقم الوطني"
              Icon={FaIdCard}
              type="text"
              value={values.national_id}
              onChange={handleChange}
              error={errors.national_id}
            />
          </div>


          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              name="password"
              placeholder="كلمة السر"
              Icon={FaLock}
              type="password"
              value={values.password}
              onChange={handleChange}
              error={errors.password}
            />
            <InputField
              name="password_confirmation"
              placeholder="تأكيد كلمة السر"
              Icon={FaLock}
              type="password"
              value={values.password_confirmation}
              onChange={handleChange}
              error={errors.password_confirmation}
            />
          </div>


          <div className="grid grid-cols-1 gap-4">
            <InputField
              name="super_admin_secret"
              placeholder="رمز المشرف العام"
              Icon={FaLock}
              type="password"
              value={values.super_admin_secret}
              onChange={handleChange}
              error={errors.super_admin_secret}
            />
          </div>

          <Button type="submit" disabled={isLoading}>
            {isLoading ? (
              <div className="flex items-center gap-3 m-1">
                <Loading type="dots" size="md" text="جاري التسجيل ..." color="light" />
              </div>
            ) : (
              "التالي"
            )}
          </Button>
          {apiError && <Alert type="error">{apiError}</Alert>}
          {success && <Alert type="success">{success}</Alert>}
        </form>

        <div className="text-center mt-4 text-sm">
          <span className="text-grayish-600">تمتلك حساب بالفعل؟ </span>
          <Link to="/login" className="text-main2 font-bold">
            سجل دخول
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Register;

